import merge from "lodash/merge";

// messages
import englishMessage from "./i18n/en";
import hindiMessage from "./i18n/hi";
import { isEmpty } from "./utils/helpers";

import { LocaleId } from "./utils/types";
import { dataProvider } from "./App";
import { RestMethods } from "jazasoft";

const i18nProvider = (locale, tenantId) => {
  let message = englishMessage;
  if (locale === LocaleId.Hindi) {
    message = hindiMessage;
  }

  if (!isEmpty(tenantId)) {
    const options = {
      url: "i18n",
      method: "get",
      params: { locale, tenantId },
    };
    return dataProvider(RestMethods.CUSTOM, null, options).then(response => {
      const serverMessage = response.data || {};
      const mergedMessage = merge(message, serverMessage);
      return Promise.resolve({...mergedMessage});
    });
  } else {
    return message;
  }
};

export default i18nProvider;
